import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type AddLegBody = components["schemas"]["AddLegBody"];
type TradeResponse = components["schemas"]["TradeResponse"];

export type AddLegVariables = {
  tradeId: string;
  body: AddLegBody;
};

export function useAddLeg() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TradeResponse, Error, AddLegVariables>({
    mutationFn: async ({ tradeId, body }) => {
      const { data, error } = await client.POST("/api/trades/{trade_id}/legs", {
        params: { path: { trade_id: tradeId } },
        body,
      });
      if (error !== undefined) {
        throw new Error(`Failed to add leg to trade ${tradeId}`);
      }
      return data;
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
      void queryClient.invalidateQueries({
        queryKey: [...TRADES_QUERY_KEY, "detail", variables.tradeId],
      });
    },
  });
}
